// Mock data for the landing page
export const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "Emprendedora",
    message: "En 6 meses logré ahorrar más que en 5 años. La clave fue automatizar.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
    savings: "$45,000"
  },
  {
    id: 2,
    name: "Carlos Ramírez",
    role: "Profesional IT",
    message: "Antes gastaba todo mi sueldo. Ahora tengo un fondo de emergencia sólido.",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
    savings: "$82,000"
  },
  {
    id: 3,
    name: "Ana Martínez",
    role: "Diseñadora",
    message: "El interés compuesto es real. ¡Mi dinero trabaja para mí ahora!",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
    savings: "$120,000"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Automatización Total",
    description: "Tu ahorro se realiza antes de que puedas gastarlo",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Interés Compuesto",
    description: "Tu dinero genera más dinero con el paso del tiempo",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Sin Esfuerzo",
    description: "Configura una vez y olvídate del resto",
    icon: "Target"
  },
  {
    id: 4,
    title: "Crecimiento Constante",
    description: "Disciplina financiera que construye tu patrimonio",
    icon: "Wallet"
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Cómo funciona la automatización?",
    answer: "Configuras un monto fijo o porcentaje de tu ingreso que se transfiere automáticamente a tu inversión antes de que llegue a tu cuenta corriente."
  },
  {
    id: 2,
    question: "¿Es seguro invertir así?",
    answer: "Sí. Trabajamos con instituciones financieras reguladas en México. La diversificación y el tiempo son tus mejores aliados."
  },
  {
    id: 3,
    question: "¿Cuánto debo ahorrar mensualmente?",
    answer: "Se recomienda al menos el 10-20% de tus ingresos. Nuestra calculadora te ayuda a encontrar el monto ideal para ti."
  },
  {
    id: 4,
    question: "¿Puedo retirar mi dinero cuando quiera?",
    answer: "Depende del producto financiero que elijas. Algunos ofrecen liquidez inmediata, otros requieren plazos mínimos para mejores rendimientos."
  }
];

// Mock test result helper (used by frontend for instant test feedback)
export const mockTestResult = (score) => {
  if (score <= 3) {
    return {
      profile: "Perfil Impulsivo 🚨",
      description: "Tu dinero entra y sale como inquilino sin contrato. 'Algún día empiezo' lleva 4 quincenas diciéndote eso. Spoiler: ese día no llega solo.",
      color: "#FF4444",
      recommendation: "Automatiza el 5% HOY mismo (sí, antes de cerrar esta pestaña). Lo que no ves, no lo gastas."
    };
  } else if (score <= 5) {
    return {
      profile: "Perfil Intermedio 🤔",
      description: "Ahorras cuando te acuerdas, gastas cuando se te antoja. La intermitencia no construye patrimonio, construye remordimiento. Pero hay potencial.",
      color: "#FFB800",
      recommendation: "Sube a 10-15% automático. Quítatelo el día 1 del mes y deja de jugar con tu fuerza de voluntad."
    };
  }
  return {
    profile: "Perfil Disciplinado 🏆",
    description: "Mírate, una persona adulta funcional financieramente. Ya entendiste el juego: el dinero invertido se reproduce solo mientras tú duermes.",
    color: "#39FF14",
    recommendation: "Sube a 20%+ y diversifica. El siguiente nivel no es ahorrar más, es invertir mejor. Tu yo de 60 te invitará tacos."
  };
};

// Impact statistics
export const impactStats = [
  { id: 1, value: 800, label: "Clientes Activos", suffix: "+" },
  { id: 2, value: 40, label: "Millones Ahorrados", prefix: "$", suffix: "M+" },
  { id: 3, value: 180, label: "Metas Alcanzadas", suffix: "+" },
  { id: 4, value: 94, label: "Satisfacción", suffix: "%" }
];

// Goal presets
export const goalPresets = [
  { id: 1, name: "Fondo de Emergencia", amount: 50000, monthlyAmount: 1500, icon: "Shield" },
  { id: 2, name: "Enganche de Casa", amount: 200000, monthlyAmount: 5000, icon: "Home" },
  { id: 3, name: "Auto Nuevo", amount: 100000, monthlyAmount: 3000, icon: "Car" },
  { id: 4, name: "Vacaciones Soñadas", amount: 30000, monthlyAmount: 1500, icon: "Plane" },
  { id: 5, name: "Retiro Anticipado", amount: 500000, monthlyAmount: 5000, icon: "Palmtree" },
  { id: 6, name: "Meta Personalizada", amount: 0, monthlyAmount: 0, icon: "Target" }
];

// Challenge categories for 30-day challenge
export const challengeCategories = [
  { id: 1, name: "Café diario", icon: "Coffee", avgCost: 50, emoji: "☕" },
  { id: 2, name: "Delivery de comida", icon: "UtensilsCrossed", avgCost: 150, emoji: "🍔" },
  { id: 3, name: "Apps de streaming", icon: "Tv", avgCost: 200, emoji: "📺" },
  { id: 4, name: "Compras impulsivas", icon: "ShoppingBag", avgCost: 500, emoji: "🛍️" },
  { id: 5, name: "Cigarros", icon: "Cigarette", avgCost: 100, emoji: "🚬" },
  { id: 6, name: "Salidas nocturnas", icon: "Wine", avgCost: 800, emoji: "🍷" },
  { id: 7, name: "Snacks", icon: "Cookie", avgCost: 40, emoji: "🍪" },
  { id: 8, name: "Taxi/Uber", icon: "Car", avgCost: 200, emoji: "🚗" }
];

// 18-month challenge milestones
export const challenge18Milestones = [
  { month: 1, title: "Primer Mes", description: "Configuraste tu ahorro automático", reward: "🎖️ Nivel: Principiante (pero ya empezaste)", icon: "Rocket" },
  { month: 3, title: "Trimestre Cumplido", description: "3 meses de disciplina constante", reward: "🏅 Nivel: Ya no es suerte", icon: "Award" },
  { month: 6, title: "Medio Año", description: "¡Has ahorrado por 6 meses!", reward: "💪 Nivel: Comprometido de verdad", icon: "Medal" },
  { month: 9, title: "9 Meses de Éxito", description: "Tres cuartos del camino", reward: "⭐ Nivel: Imparable", icon: "Star" },
  { month: 12, title: "Un Año Completo", description: "12 meses de ahorro automático", reward: "👑 Nivel: Maestro del Ahorro", icon: "Crown" },
  { month: 18, title: "Hábito Consolidado", description: "¡Completaste el reto de 18 meses!", reward: "🏆 Nivel: Leyenda Financiera + Beneficios Exclusivos", icon: "Trophy" }
];

// Allianz products
export const allianzProducts = [
  {
    id: 1,
    name: "Optimaxx Plus",
    provider: "Allianz México",
    description: "Plan de ahorro e inversión diseñado para maximizar tu patrimonio con rendimientos competitivos y flexibilidad.",
    features: [
      "Rendimientos competitivos superiores al mercado",
      "Flexibilidad en montos y plazos de inversión",
      "Protección con respaldo de Allianz",
      "Liquidez para emergencias (aplican condiciones del producto)",
      "Asesoría personalizada incluida"
    ],
    benefits: [
      "Automatización de aportes mensuales",
      "Retiros parciales",
      "Aumento o disminución de aportación",
      "Suspensión de aportaciones",
      "Periodo de descanso",
      "Aportaciones adicionales que maximizan el rendimiento",
      "Acceso a diferentes alternativas de inversión: IPC, S&P500, NASDAQ, Oro, Mercados Emergentes, EUROSTOCK",
      "Inversión en diferentes monedas",
      "Perfil de inversionista: conservador, moderado y dinámico"
    ],
    idealFor: "Personas que buscan disciplina financiera con el respaldo de una institución sólida",
    minAmount: 2000,
    recommendedMonthly: 3000,
    icon: "TrendingUp",
    color: "#39FF14"
  }
];
